module.exports = __webpack_public_path__ + "img/IT0000171702348.19468400.png";